var _path, _path2, _path3, _ellipse, _path4, _ellipse2, _path5, _ellipse3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriteForUsBannerPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 98,
    viewBox: "0 0 375 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.03 55.3107C296.441 54.1478 292.225 66.9205 292.225 73.1224V83.5881H329.117C327.852 83.2974 329.539 80.7973 325.322 73.1224C321.106 65.4475 316.96 69.9245 315.414 73.1224C314.009 67.8895 311.619 56.4736 304.03 55.3107Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.011 65.9146C267.355 65.1878 263.102 73.1707 263.102 77.0469V83.588H300.318C299.042 83.4063 300.743 81.8438 296.49 77.0469C292.236 72.2501 288.054 75.0483 286.494 77.0469C285.077 73.7764 282.667 66.6414 275.011 65.9146Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 82.5723L375 82.5722",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.003,
    cy: 39.6257,
    rx: 14.1614,
    ry: 19.3855,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.002 87.5018V46.6748",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.308,
    cy: 47.8493,
    rx: 14.1614,
    ry: 19.3855,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.309 95.7254V54.8984",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.526,
    cy: 57.9988,
    rx: 7.36984,
    ry: 16.9392,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.527 89.1631V68.7773",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.33 78.3057L196.33 82.5716",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.182 73.3291V82.572",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.176 73.3291V82.572",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4609 73.3291V82.572",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1504 37.8097L66.2711 2.40527L88.8984 37.8097",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6699 39.4944L55.8542 28.2549V75.4607",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3711 1H123.177L139.804 30.7846",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.287 42.5869V72.6526",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.5176,
    y: 30.5039,
    width: 7.38958,
    height: 10.6775,
    fill: "#CADDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5176,
    y: 43.9922,
    width: 14.3686,
    height: 10.6775,
    fill: "#CADDFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5176,
    y: 59.1641,
    width: 7.38958,
    height: 16.2973,
    fill: "#F3C477"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4102 41.7432V74.8997",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0039 15.6109V1.56152H58.3145V9.71015",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteForUsBannerPhone);
export default __webpack_public_path__ + "static/media/write-for-us-banner-phone.45dfda95.svg";
export { ForwardRef as ReactComponent };